import React, { useState, useEffect } from 'react';

interface TimerProps {
  initialMiliseconds: number;
  timerActive: boolean;
  seconds: number;
  setSeconds: React.Dispatch<React.SetStateAction<number>>
  setTimerActive: React.Dispatch<React.SetStateAction<boolean>>;
}

const Timer: React.FC<TimerProps> = ({ initialMiliseconds, seconds, setSeconds, timerActive, setTimerActive }) => {
  const [hideTimer, setHideTimer] = useState("hidden")

  const tickTimer = () => {
    if (seconds > 0) {
      setTimeout(() => setSeconds(seconds - 1000.0), 1000)
    } else {
      setSeconds(initialMiliseconds)
    }
  }

  const resetTimer = () => {
    setSeconds((initialMiliseconds / 1000 ))
    setTimerActive(false)
  }

  useEffect(() => {
    tickTimer()
    if (seconds === 0) {
      if (timerActive) {
        resetTimer()
      }
    }
  }, [seconds])

  useEffect(() => {
    setHideTimer('inline')
  })

  return (
    <>
      {timerActive ? <div className="inline-block">
        <span className={`${hideTimer} text-xl font-bold mb-4`}>
          {seconds/1000}
        </span>
      </div> : <></>
      }
    </>
  );
};

export default Timer;